<template>
  <Modal :show.sync="show" class="residential-account-contact-seller">
    <Card tag="form" theme="flat" @submit.prevent="submit">
      <template #header>
        <Seller v-if="seller" :value="seller" />
      </template>
      <template #default>
        <InputComponent :label="$t('complaintTermsOfRequest')" v-model="data.title" data-widget="terms" required />
        <InputComponent :label="$t('description')" data-widget="description" required>
          <textarea
            v-model="data.description"
            rows="3"
            class="elder-input__element"
            :placeholder="$t('typeHere') + '...'"
          ></textarea>
        </InputComponent>

        <FileComponent v-model="data.images" data-widget="images" :label="$tc('image', 2)" accept="image/*" multiple />

        <FileComponent v-model="data.attachments" data-widget="attachment" :label="$tc('attachment', 2)" multiple />
      </template>
      <template #footer>
        <slot name="footer" />
        <ButtonComponent :label="$t('cancel')" @click="show = false" :icon="['fal', 'times']" />
        <ButtonComponent
          type="submit"
          :promise="promise"
          :disabled="!validator.passes"
          :label="$t('send')"
          theme="primary"
          :icon="['fal', 'paper-plane']"
          @onSuccess="success"
        />
      </template>
    </Card>
  </Modal>
</template>

<script>
import Validator from '@/mixins/validator-v2'
import { mapActions, mapMutations, mapState } from 'vuex'
import ModelMixin from '@/mixins/Model'
import Bus from '@/bus'

import { ModalComponent as Modal } from 'vue-elder-modal'
import { InputComponent } from 'vue-elder-input'
import Card from '@/components/Card'
import { FileComponent } from '@kvass/file'
import { CheckboxComponent } from 'vue-elder-checkbox'
import Seller from './Seller'

export default {
  mixins: [
    Validator({
      rules: {
        title: 'required',
        attachments: 'array',
        description: 'required',
      },
      data: 'data',
    }),
    ModelMixin({
      source: 'item',
      model: {
        title: null,
        description: null,
        dueAt: null,
        members: [],
        images: [],
        attachments: [],
        tags: [],
      },
      transform: {
        members(v) {
          return v && v.map(e => e.id)
        },
      },
    }),
  ],
  watch: {
    data: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
  data() {
    return {
      promise: null,
      show: false,
    }
  },
  computed: {
    ...mapState('ResidentialAccount', { item: 'item', reference: state => state.item.reference }),
    seller() {
      let complaintManager = this.$path('project.roles.complaint.manager.0', this.reference)

      return complaintManager ? complaintManager : this.$path('project.roles.salesman.0', this.reference)
    },
  },
  methods: {
    ...mapMutations('Task', ['set']),
    ...mapActions('Task', ['mutate']),
    submit() {
      if (!this.validator.passes) return
      return (this.promise = this.mutate([
        {
          ...this.getData({ diff: false }),
          reference: {
            ref: this.item.id,
            onModel: 'ResidentialAccount',
          },
          status: 'request',
        },
      ]))
    },
    success() {
      this.data.title = null
      this.data.description = null
      this.data.images = []
      this.data.attachments = []

      this.show = false
    },
    init() {
      if (this.$store.state.user) {
        this.data.email = this.$store.state.user.email
        this.data.name = this.$store.state.user.name
      }

      Bus.$on('contact-seller:show', () => {
        this.show = true
      })
    },
  },
  created() {
    if (!this.data.members.length && this.$store.state.user)
      this.data.members.push({
        id: this.$store.state.user.id,
        name: this.$store.state.user.name,
        email: this.$store.state.user.email,
        avatar: this.$store.state.user.avatar,
      })

    this.init()
  },

  components: {
    Card,
    InputComponent,
    FileComponent,
    CheckboxComponent,
    Modal,
    Seller,
  },
}
</script>

<style lang="scss">
.residential-account-contact-seller {
  .card {
    width: 100%;
    max-width: 600px;
    &__header {
      gap: 1rem;
      min-height: initial;

      & > svg {
        margin-right: 1.5rem;
      }

      h2 {
        margin: 0;
      }
    }

    &__footer-content {
      justify-content: flex-end;
    }

    .card__content {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 1rem 1rem;
      align-items: flex-start;
    }
  }
}
</style>
